<div *ngIf="reportType == 'Bookoutstandingbriefly'">

  <!-- ACTION BUTTONS -->
  <div style="margin-left:80%; margin-top:2%;" class="noPrint">
    <button (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">Export</button>
    <button class="btn btn-primary" (click)="printPageA41()">Print</button>
    <button mat-button mat-dialog-close>Close</button>
  </div>

  <!-- PRINT SECTION -->
  <div id="print-section">

    <!-- ================= MAIN HEADER (FIRST PAGE ONLY) ================= -->
    <div class="main-header-wrapper">
      <table style="width:100%; border-collapse:collapse; margin-bottom:0;">

        <thead>
          <tr>
            <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;border-left:1px solid black;border-right:1px solid black;border-top:1px solid black;">
              हिंदुस्तान प्रकाशन संस्था 
            </td>

            <td style="font-size:20px; font-weight:bold; text-align:center; padding:8px;border-right:1px solid black;border-top:1px solid black;">
              Book Outstanding Report 
            </td>

            <td style="font-size:18px; text-align:right; padding:8px;border-right:1px solid black;border-top:1px solid black; font-weight: bold;">
              दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

          <tr style="border-top:1px solid black;">
            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;border-left:1px solid black;">
               विवेक पुस्तक प्रकाशन
            </td>

            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;">
              All Briefly
            </td>

            <td style="font-size:16px; text-align:right; padding:8px; white-space:nowrap;border-right:1px solid black; font-weight: bold;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }}
              To {{ endDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>
        </thead>

      </table>
    </div>

    <!-- ================= MAIN DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse;">

      <!-- ================= COLUMN HEADER (REPEAT EVERY PAGE) ================= -->
      <thead class="repeat-header">
        <tr style="font-weight:bold; background:#e4e4e4;">
          <th style="border:1px solid black; padding:6px; text-align:left;">Representative Name</th>
          <th style="border:1px solid black; padding:6px; text-align:center;">Contact No</th>
          <th style="border:1px solid black; padding:6px; text-align:center;">Invoice<br>Amount</th>
          <th style="border:1px solid black; padding:6px; text-align:center;">Paid<br>Amount</th>
          <!-- <th style="border:1px solid black; padding:6px; text-align:center;">Credit Amount</th> -->
          <th style="border:1px solid black; padding:6px; text-align:center;">Unpaid Amount</th>
        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody>

        <!-- LOOP OFFICE REPRESENTATIVE -->
        <ng-container *ngFor="let data of OutstandingB">

          <!-- OFFICE REP HEADER -->
          <tr >
            <td colspan="6" style="border:1px solid black; padding:8px; font-weight:bold; font-size:18px;">
              Office Representative Name : {{data.off_rep_name}}
            </td>
          </tr>

          <!-- REPRESENTATIVE ROWS -->
          <tr *ngFor="let data1 of data.rep_data">

            <td style="border:1px solid black; padding:6px;">
              {{data1.rep_name}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:center;">
              {{data1.rep_mobile_no}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data1.inv_amt_total}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data1.net_amt_total}}
            </td>
<!-- 
            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data1.crdt_amt_total}}
            </td> -->

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data1.unpaid_amt_total}}
            </td>

          </tr>

          <!-- SUBTOTAL ROW -->
          <tr style=" font-weight:bold;background:#f4b084;">
            <td colspan="2" style="border:1px solid black; padding:6px;">
              Total: {{data.off_rep_name}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data.inv_Total}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data.paid_Total}}
            </td>

            <!-- <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data.crdt_Total}}
            </td> -->

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data.bal_Total}}
            </td>
          </tr>

        </ng-container>

        <!-- ================= GRAND TOTAL ================= -->
        <tr style="background:#c8753f; font-weight:bold; color:white; font-size:16px;">
          <td colspan="2" style="border:1px solid black; padding:8px;">
            Grand Total:
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalInvAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalPaidAmount }}
          </td>

          <!-- <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalCrdtAmount }}
          </td> -->

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalUnpaidAmount }}
          </td>
        </tr>

      </tbody>

    </table>

  </div>

</div>
